import { render, staticRenderFns } from "./help.vue?vue&type=template&id=fd011338&scoped=true&"
import script from "./help.vue?vue&type=script&lang=ts&"
export * from "./help.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd011338",
  null
  
)

export default component.exports